<div class="dialog-wrapper non-rentable">
  <div class="dialog__header">
    <header l10nTranslate>actionsToolbar.nonRentableSpace</header>
    <div class="instructions">
      <span class="required-icon"> &#x2a; </span>
      <span class="required-label">{{ 'recordsSearch.efficienciesWizards.requiredFields' | xTranslate }}</span>
    </div>
    <mat-icon class="dialog-close" aria-hidden="false" mat-dialog-close>close</mat-icon>
  </div>
  <div class="dialog__contents">
    <form [formGroup]="nonRentableSpaceFG" class="">
      <span [ngClass]="isIndiaUsr ? 'error-msg' : 'warning-msg'" *ngIf="spaceValidatnMsg">
        {{ 'recordsSearch.efficienciesWizards.exceededFlorSize' | xTranslate }}
      </span>
      <div class="nrs__forms">
        <div class="nrs__forms__item form-container">
          <label>
            <div>
              {{ 'actionsToolbar.spaceName' | xTranslate }}
              <span class="required-icon"> &#x2a; </span>
            </div>
          </label>
          <div class="dropdown-container non-table">
            <mat-form-field class="mat-select-field miq-form-input" floatLabel="never" appearance="outline">
              <mat-select
                hideSingleSelectionIndicator="true"
                #stSelect
                panelClass="custom-dropdown"
                name="spaceName"
                formControlName="spaceName"
                [placeholder]="'commonLabels.select' | xTranslate"
                (focus)="stSelect.open()"
              >
                <mat-option>--</mat-option>
                <mat-option *ngFor="let type of spaceType" [value]="type.key" (click)="stSelect.close()">
                  {{ type.value }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="nrs__forms__item form-container">
          <label>
            <div>
              {{ 'actionsToolbar.floor' | xTranslate | titlecase }}
              <span class="required-icon"> &#x2a; </span>
            </div>
          </label>
          <div class="dropdown-container non-table">
            <mat-form-field class="mat-select-field miq-form-input" floatLabel="never" appearance="outline">
              <mat-select
                hideSingleSelectionIndicator="true"
                #foSelect
                panelClass="custom-dropdown"
                name="floorNumber"
                formControlName="floorNumber"
                [placeholder]="'commonLabels.select' | xTranslate"
                (focus)="foSelect.open()"
              >
                <mat-option>--</mat-option>
                <mat-option
                  *ngFor="let floor of floorsOptions"
                  [value]="floor.value"
                  [disabled]="floor.disabled"
                  (click)="foSelect.close()"
                >
                  {{ floor.label }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="nrs__forms__item form-container">
          <label l10nTranslate
            >actionsToolbar.suite
            <mat-icon
              class="tooltip-icon"
              svgIcon="tooltip"
              [matTooltip]="'errorMessages.nonRentableSpaceBlankSuiteWarning' | xTranslate"
              matTooltipClass="tooltip-custom"
              matTooltipPosition="above"
            ></mat-icon
          ></label>
          <div class="form-container__item">
            <input type="text" name="suiteNo" class="text-input" formControlName="suiteNo" />
          </div>
        </div>
        <div class="nrs__forms__item form-container">
          <label l10nTranslate>commonLabels.spaceSize</label>
          <div class="form-container__item optselect">
            <input type="number" class="text-input" name="spaceSize" formControlName="spaceSize" />
            <mat-form-field class="mat-select-field miq-form-input" floatLabel="never" appearance="outline">
              <mat-select
                hideSingleSelectionIndicator="true"
                #ssSelect
                [placeholder]="'commonLabels.select' | xTranslate"
                panelClass="custom-dropdown"
                name="spaceSizeUOM"
                formControlName="spaceSizeUOM"
                (focus)="ssSelect.open()"
              >
                <mat-option (click)="ssSelect.close()">--</mat-option>
                <mat-option *ngFor="let uom of uomValues" [value]="uom.key" (click)="ssSelect.close()">
                  {{ uom.value }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class="nrs__forms">
        <div class="nrs__forms__item full form-container">
          <label l10nTranslate>commonLabels.notes</label>
          <div class="form-container__item textarea">
            <textarea name="note" formControlName="note"></textarea>
          </div>
        </div>
      </div>
    </form>
    <div class="button-container">
      <button
        mat-flat-button
        color="primary"
        type="button"
        [disabled]="nonRentableSpaceFG.invalid || nonRentableSpaceFG.pristine"
        (click)="submit()"
        l10nTranslate
      >
        commonLabels.save
      </button>
    </div>
  </div>
</div>
